import type { ProcessStatus } from '../../../../bridge/types/process.ts';

export const PROCESS_STATUS_CONFIG: Record<
	ProcessStatus,
	{
		label: string;
		variant: 'neutral' | 'notice' | 'positive' | 'negative' | 'informative';
	}
> = {
	proposed: { label: 'Proposed', variant: 'informative' },
	active: { label: 'Active', variant: 'positive' },
	cancelled: { label: 'Cancelled', variant: 'neutral' },
	paused: { label: 'Paused', variant: 'neutral' },
};
